import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const albumImporterSelectors = importerSelectors(
  'album.importer',
)

export default albumImporterSelectors
